import {
  getSnackbarStyle
} from "./chunk-6FDAA7GW.mjs";

// src/snackbar.component.tsx
import { memo, useEffect, useMemo, useState } from "react";
import { motion, useIsPresent } from "framer-motion";
import Box from "@mui/material/Box";
import { useTimeout, useUpdateEffect } from "@clara/hooks";
import { runIfFn } from "@clara/utils";
import { jsx } from "react/jsx-runtime";
var snackbarMotionVariants = {
  initial: (props) => {
    const { position } = props;
    const dir = ["top", "bottom"].includes(position) ? "y" : "x";
    let factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
    if (position === "bottom")
      factor = 1;
    return {
      opacity: 0,
      [dir]: factor * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var SnackbarComponent = memo(function SnackbarComponent2(props) {
  const {
    id,
    message,
    onCloseComplete,
    onRequestRemove,
    requestClose = false,
    position = "bottom",
    duration = 5e3,
    containerStyle,
    motionVariants = snackbarMotionVariants,
    snackbarSpacing = "0.5rem"
  } = props;
  const [delay, setDelay] = useState(duration);
  const isPresent = useIsPresent();
  useUpdateEffect(() => {
    if (!isPresent) {
      onCloseComplete == null ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  useUpdateEffect(() => {
    setDelay(duration);
  }, [duration]);
  const onMouseEnter = () => setDelay(null);
  const onMouseLeave = () => setDelay(duration);
  const close = () => {
    if (isPresent)
      onRequestRemove();
  };
  useEffect(() => {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  useTimeout(close, delay);
  const containerStyles = useMemo(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 200,
      margin: snackbarSpacing,
      ...containerStyle
    }),
    [containerStyle, snackbarSpacing]
  );
  const snackbarStyle = useMemo(() => getSnackbarStyle(position), [position]);
  return /* @__PURE__ */ jsx(
    motion.div,
    {
      layout: true,
      className: "ui-snackbar",
      variants: motionVariants,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: onMouseEnter,
      onHoverEnd: onMouseLeave,
      custom: { position },
      style: snackbarStyle,
      children: /* @__PURE__ */ jsx(
        Box,
        {
          role: "status",
          "aria-atomic": "true",
          className: "ui-snackbar__inner",
          sx: containerStyles,
          children: runIfFn(message, { position, id, onClose: close })
        }
      )
    }
  );
});

export {
  SnackbarComponent
};
